import { Stack, Typography, CircularProgress, Box } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';

interface Props {
  text: string;
  spinner?: boolean;
}

const SystemMessageCard = ({ text, spinner }: Props) => {
  const theme = useTheme();
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ my: 1, pl: 0.25 }}>
      {spinner ? (
        <CircularProgress
          size={11}
          thickness={5}
          sx={{ color: theme.palette.text.disabled, flexShrink: 0 }}
        />
      ) : (
        <Box
          sx={{
            width: 4,
            height: 4,
            borderRadius: '50%',
            bgcolor: alpha(theme.palette.text.disabled, 0.6),
            flexShrink: 0,
          }}
        />
      )}
      <Typography
        sx={{
          color: alpha(theme.palette.text.primary, 0.62),
          fontSize: '0.8125rem',
          lineHeight: 1.5,
          fontStyle: 'italic',
        }}
      >
        {text}
      </Typography>
    </Stack>
  );
};

export default SystemMessageCard;
